import { render, staticRenderFns } from "./SensorModelForm.vue?vue&type=template&id=71196754&scoped=true&"
import script from "./SensorModelForm.vue?vue&type=script&lang=js&"
export * from "./SensorModelForm.vue?vue&type=script&lang=js&"
import style0 from "./SensorModelForm.vue?vue&type=style&index=0&id=71196754&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71196754",
  null
  
)

export default component.exports